import { TEnabledSurvey } from '@lootboy/lib/slices/surveys/types';

import Image from '~/components/Image';
import NewTabOpener from '~/components/NewTabOpener';

import styles from './SurveyHeroImage.module.scss';

export function SurveyHeroImage({
  image,
}: {
  image: TEnabledSurvey['logo'];
}): JSX.Element {
  if (!image) return <></>;

  if (image.url) {
    return (
      <NewTabOpener
        href={image.url}
        className=""
      >
        <Image
          alt={image.alt ?? ''}
          path={image.image ?? ''}
          title={image.title}
          className={styles.heroImage}
        />
      </NewTabOpener>
    );
  }

  return (
    <Image
      alt={image.alt ?? ''}
      path={image.image ?? ''}
      title={image.title}
      className={styles.heroImage}
    />
  );
}
